import axiosApiInstance from "../../../app/axios";
import { PARKIT_API_BASE_URL } from "../../../app/utils";
import { getJwtToken } from "../../../app/common";

export const getAllSeasonPassProducts = async (
  page,
  size,
  sort,
  sortBy,
  parkingAreaId
) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/season-pass-products?&page=${page}&size=${size}&sort=${sort}&sortBy=${sortBy}${
      parkingAreaId ? `&parkingAreaId=${encodeURIComponent(parkingAreaId)}` : ""
    }`,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const createSeasonPassProduct = async (data) =>
  axiosApiInstance.post(
    `${PARKIT_API_BASE_URL}/parkit/v2/season-pass-products`,
    data,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const updateSeasonPassProduct = async (id, data) =>
  axiosApiInstance.put(
    `${PARKIT_API_BASE_URL}/parkit/v2/season-pass-products/${id}`,
    data,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const updateSeasonPassProductAvailability = async (id, isActive) =>
  axiosApiInstance.put(
    `${PARKIT_API_BASE_URL}/parkit/v2/season-pass-products/${id}/availability`,
    { isActive },
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const deleteSeasonPassProduct = async (id) =>
  axiosApiInstance.delete(
    `${PARKIT_API_BASE_URL}/parkit/v2/season-pass-products/${id}`,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const getParkingAreasForSelect = async () => {
  const content = [];
  let page = 0;
  let response;

  do {
    response = await axiosApiInstance.get(
      `${PARKIT_API_BASE_URL}/parkit/v2/parking-areas?&page=${page}&size=1000&sort=asc&sortBy=name`,
      { headers: { Authorization: `Bearer ${getJwtToken()}` } }
    );
    content.push(...(response.data.content ?? []));
    page += 1;
  } while (page < response.data.totalPages);

  return { ...response, data: { ...response.data, content } };
};

export const getActiveCpmsConnections = async () =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/cpms-connections`,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );
